import type { IndicatorTemplate, KLineData } from 'klinecharts';

interface PvtResult {
  pvt?: number;
}

// klinecharts@9.8.12 bundles a broken built-in PVT: its own comment documents
// X = (Close - PrevClose)/PrevClose * Volume, but the shipped calc computes
// X = (Close - PrevClose)/(PrevClose * Volume) — dividing by volume instead of
// multiplying. For any symbol with real trading volume this crushes every
// day's contribution toward zero, so the line reads as flat (e.g. AEL.N0000).
// Fixed upstream only in klinecharts v10 (a breaking major this app hasn't
// adopted) — reimplement the documented formula here and re-register under
// the same 'PVT' name, which overrides the library's built-in entry.
export const pvt: IndicatorTemplate<PvtResult> = {
  name: 'PVT',
  shortName: 'PVT',
  figures: [{ key: 'pvt', title: 'PVT: ', type: 'line' }],
  calc: (dataList: KLineData[]) => {
    let sum = 0;
    return dataList.map((kLineData, i) => {
      const close = kLineData.close;
      const volume = kLineData.volume ?? 1;
      const prevClose = (dataList[i - 1] ?? kLineData).close;
      let x = 0;
      if (prevClose !== 0) {
        x = ((close - prevClose) / prevClose) * volume;
      }
      sum += x;
      return { pvt: sum };
    });
  },
};

export default pvt;
